import cn from 'clsx';
import { sanitize } from 'dompurify';
import parse from 'html-react-parser';
import React, { type FC } from 'react';
import { DeviceTypeEnum } from '../../types/DeviceType';
import { DH } from '../../utils/DataHook';
import { getFormattedPrice } from '../../utils/getFormattedPrice';
import { t } from '../../utils/i18n';
import s from './styles.scss';
import { type PaymentCompleteProps } from './types';

export const PaymentComplete: FC<PaymentCompleteProps> = (props) => {
  const { paymentResult, orderDescription, dateNumberFormat, deviceType } = props;
  const { chargeId } = paymentResult;
  const isPending = paymentResult.clientStatus === 'Pending' || paymentResult.clientStatus === 'InProcess';
  const amount: string = getFormattedPrice({
    locale: dateNumberFormat,
    price: orderDescription.amount,
    currency: orderDescription.currency,
  });
  const customerEmail: string = orderDescription.billingAddress?.email;

  return (
    <div
      data-hook={DH.PaymentComplete.Container}
      data-status={isPending ? 'pending' : 'success'}
      className={cn(s.wrapper, deviceType === DeviceTypeEnum.mobile && s.mobile)}
    >
      <h2 data-hook={DH.PaymentComplete.Title} className={s.title}>
        {t(`paymentComplete.title.${isPending ? 'pending' : 'success'}`)}
      </h2>
      <div data-hook={DH.PaymentComplete.Description}>
        <div className={s.info}>
          {t(`paymentComplete.transaction.${isPending ? 'pending' : 'success'}`, { amount })}
          {customerEmail && (
            <div>
              {parse(
                sanitize(
                  t(`paymentComplete.transaction.${isPending ? 'pending' : 'success'}.email`, { customerEmail }),
                ),
              )}
            </div>
          )}
        </div>
        <div className={s.transaction}>{t('paymentComplete.transaction.id', { transactionId: chargeId })}</div>
      </div>
    </div>
  );
};
